import AbonementCardContainer from './AbonementCardContainer';

export default AbonementCardContainer;
